import { useThree } from '@react-three/fiber'
import { useRuntimeVariables } from 'app-kit'
import { useGeckoAuth } from 'features/auth'
import { RolodexTilesPlugin } from 'features/siteView'
import {
  CompassGizmo,
  ReorientationPlugin,
  TilesFadePlugin,
  TilesPluginR3f,
  TilesRendererR3f,
} from 'gecko-3d-tiles-renderer'
import { PointCloudOctree } from 'gecko-potree-core'
import React, { FC, useEffect, useMemo, useRef } from 'react'
import * as THREE from 'three'
import { GeckoSiteModelOrientation } from 'types'

interface MaxarTilesProps {
  siteModelID: string
  siteModelOrientation?: GeckoSiteModelOrientation
}

export const MaxarTiles: FC<MaxarTilesProps> = ({
  siteModelID,
  siteModelOrientation,
}) => {
  const { ROLODEX_URL } = useRuntimeVariables()
  const { authorizedAxios: axios } = useGeckoAuth()

  const rolodexPluginOptions = useMemo(() => {
    return {
      entryID: siteModelID,
      rootPath: 'vricon_3dtiles',
      axios,
      rolodexURL: ROLODEX_URL,
    }
  }, [ROLODEX_URL, axios, siteModelID])

  const groupRef = useRef<THREE.Group>(null)
  const { scene } = useThree()
  useEffect(() => {
    setInterval(() => {
      groupRef.current?.traverse((object) => {
        const mesh = object as PointCloudOctree
        if (mesh.material) {
          mesh.material.polygonOffset = true
          mesh.material.polygonOffsetFactor = 100
          mesh.material.polygonOffsetUnits = 30
          mesh.material.needsUpdate = true
        }
      })
    }, 1000)
  }, [scene])

  return (
    <group
      ref={groupRef}
      position={siteModelOrientation?.position ?? [0, 0, 0]}
      rotation={siteModelOrientation?.rotation ?? [0, 0, 0]}>
      <TilesRendererR3f url={'tileset.json'}>
        <TilesPluginR3f
          plugin={RolodexTilesPlugin}
          args={rolodexPluginOptions}
        />
        <TilesPluginR3f plugin={TilesFadePlugin} fadeDuration={500} />
        <TilesPluginR3f plugin={ReorientationPlugin} />
        <CompassGizmo margin={[100, 100]} />
      </TilesRendererR3f>
    </group>
  )
}
